module.exports = "<span *ngIf=\"!loading\">\r\n    <div echarts [options]=\"options\" class=\"demo-chart\"></div>\r\n</span>\r\n\r\n"